// this overwrites the original dictionary in src/app/core/settings/i18n/japanese.dictionary.ts
export const dictionary = {
  'ja-JP': {
    alreadyAcceptedHere: '(受付済みの方はこちら)',
    agePrefix: '享年',
  },
};
